var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-row',{staticClass:"step-box",class:_vm.stepNum},_vm._l((_vm.dataList),function(item,index){return _c('van-col',{key:index,staticClass:"step-item",attrs:{"span":"6"}},[_c('span',{staticClass:"icon-box",class:'icon'+index}),_c('span',{staticClass:"remark-box",class:'remark'+index},[_vm._v(_vm._s(item.remark))])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }